import BEM from 'bem.js';

/** @const {string} */
export const BLOCK_BUTTON = 'button';

/** @const {string} */
const MODIFIER_TOGGLE = 'toggle';

/** @const {string} Modifier indicating a primary button. */
export const MODIFIER_PRIMARY = 'primary';

/** @const {string} Modifier indicating a secondary button. */
export const MODIFIER_SECONDARY = 'secondary';

/** @const {NodeList} */
const TOGGLE_BUTTONS = BEM.getBEMNodes(BLOCK_BUTTON, false, MODIFIER_TOGGLE);


/**
 * Class for generic toggle buttons.
 * Toggle button should have MODIFIER_TOGGLE present in classList for detection.
 * Toggle button should have data-toggle-target set to query selector for target.
 * Toggle button should have data-toggle-modifier set to modifier to toggle.
 * @class
 */
class ToggleButton {
    /**
     * Constructor method.
     * @param {HTMLElement} node
     */
    constructor(node) {
        /** @type {HTMLElement} */
        this.node = node;

        /** @type {string} */
        this.target = document.querySelector(this.node.dataset.toggleTarget);

        /** @type {string} */
        this.toggleModifier = this.node.dataset.toggleModifier;

        this.restoreState();
        this.bindEvents();
    }

    /**
     * Binds events to callbacks.
     */
    bindEvents() {
        this.node.addEventListener('click', this.onClick.bind(this, undefined));
    }

    /**
     * Callback for this.node click.
     */
    onClick() {
        this.toggle();
        this.saveState();
    }

    /**
     * Performs toggle.
     * @param {booelan} [exp] If passed, add/removes this.toggleModifier based on exp.
     */
    toggle(exp=undefined) {
        BEM.toggleModifier(this.target, this.toggleModifier, exp);
    }

    /**
     * Saves state to localstorage.
     */
    saveState() {
        let id = this.node.id;
        let value = Boolean(BEM.hasModifier(this.target, this.toggleModifier));

        if (id) {
            let key = `ToggleButton#${id}.modifierApplied`;
            try {
                localStorage.setItem(key, value);
            } catch(e) {
                console.warn(this, 'Unable to save state to localstorage');
            }
        }
    }

    /**
     * Restores state from localstorage.
     */
    restoreState() {
        let id = this.node.id;

        if (id) {
            let key = `ToggleButton#${id}.modifierApplied`;
            try {
                let value = localStorage.getItem(key) || false;
                this.toggle(value.toUpperCase() === 'TRUE');
            } catch(e) {
                console.warn(this, 'Unable to restore state from localstorage');
            }
        }
    }
}

// Start!
[...TOGGLE_BUTTONS].forEach(toggleButton => new ToggleButton(toggleButton));
